import type { ICloudRegulatoryControlPoint } from "../types"
import type { RegulatoryControlAnswer } from "../generated/proto-ts/main"
import { pbUUIDToUuid } from "./utils"
export function controlAnswerKey(
  point: Pick<ICloudRegulatoryControlPoint, "UUID" | "AnswerContextUUID">,
) {
  return point.AnswerContextUUID ? `${point.AnswerContextUUID}/${point.UUID}` : point.UUID
}
export function answerKey(answer: RegulatoryControlAnswer) {
  const context =
    answer.context_uuid?.value?.length === 16 && answer.context_uuid.value.some((v) => v !== 0)
      ? pbUUIDToUuid(answer.context_uuid)
      : ""
  return controlAnswerKey({
    UUID: pbUUIDToUuid(answer.control_point_uuid),
    AnswerContextUUID: context || undefined,
  })
}
